import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './context/AuthContext';
import { UserProvider } from './context/UserContext';
import { TransactionProvider } from './context/TransactionContext';
import PrivateRoute from './components/PrivateRoute';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import OnboardingPage from './pages/OnboardingPage';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import TransactionsPage from './pages/TransactionsPage';
import BreakdownPage from './pages/BreakdownPage';
import SettingsPage from './pages/SettingsPage';
import NotFoundPage from './pages/NotFoundPage';
import AdminPage from './pages/AdminPage';
import theme from './theme';

// Optional: suppress React Router future flags warnings
// import { UNSAFE_DataRouterContext, UNSAFE_DataRouterStateContext } from 'react-router-dom';
// if (UNSAFE_DataRouterContext.providers) {
//   UNSAFE_DataRouterContext.providers = {
//     future: {
//       v7_startTransition: true,
//       v7_relativeSplatPath: true
//     }
//   };
// }

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {/* Authentication provider must come first */}
      <AuthProvider>
        {/* User provider depends on auth context */}
        <UserProvider>
          {/* Transaction provider depends on both auth and user contexts */}
          <TransactionProvider>
            <Router>
              <Routes>
                {/* Public routes */}
                <Route path="/" element={<Navigate to="/login" />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/signup" element={<SignupPage />} />
                <Route path="/reset-password" element={<ResetPasswordPage />} />
                
                {/* Onboarding route - protected by auth */}
                <Route 
                  path="/onboarding" 
                  element={
                    <PrivateRoute>
                      <OnboardingPage />
                    </PrivateRoute>
                  } 
                />
                
                {/* Protected routes inside the main layout */}
                <Route 
                  path="/" 
                  element={
                    <PrivateRoute>
                      <Layout />
                    </PrivateRoute>
                  }
                >
                  <Route index element={<HomePage />} />
                  <Route path="transactions" element={<TransactionsPage />} />
                  <Route path="breakdown" element={<BreakdownPage />} />
                  <Route path="settings" element={<SettingsPage />} />
                </Route>
                
                {/* Redirect root to home when accessing directly */}
                <Route path="/" element={<Navigate to="/home" replace />} />
                
                {/* Not found */}
                <Route path="*" element={<NotFoundPage />} />

                {/* Admin route */}
                <Route path="/admin" element={<AdminPage />} />
              </Routes>
            </Router>
          </TransactionProvider>
        </UserProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;